import { Modal, Box, Button, Typography, TextField, Fab, Paper, Divider } from '@mui/material'
import { QRCodeCanvas } from 'qrcode.react'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import PasswordIcon from '@mui/icons-material/Password'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import OTPInput from 'react-otp-input'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import ProcessingSpinner from '../../../components/common/alertFetchSpinner/processingSpinner'
import './../2FA/2fa.scss'

const TwoFactorActivationModal = ({
  open,
  onClose,
  qrCode,
  secret,
  onVerify,
  otp,
  setOtp,
  step,
  setStep,
  verifySuccess,
  isProcessing,
}) => {
  const { theme } = useSelector((state) => state.theme)
  const { t } = useTranslation(['common', 'messages'])

  const handleNext = () => {
    if (step === 0) {
      setStep(1)
    } else {
      onVerify()
    }
  }

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="2fa-modal-title" aria-describedby="2fa-modal-description">
      <Box className={`modal ${theme === 'dark' ? 'modal-dark' : 'modal-light'}`}>
        <Box className="tfa-modal-header">
          {step === 0 && !verifySuccess && (
            <QrCodeScannerIcon sx={{ gridColumn: '2', justifySelf: 'center', fontSize: '2.4rem' }} />
          )}
          {step === 1 && !verifySuccess && (
            <PasswordIcon sx={{ gridColumn: '2', justifySelf: 'center', fontSize: '2.4rem' }} />
          )}
          {verifySuccess && (
            <CheckCircleOutlineIcon sx={{ gridColumn: '2', justifySelf: 'center', fontSize: '2.4rem' }} />
          )}
          <Fab className="tfa-modal-close-button" onClick={onClose}>
            <CloseOutlinedIcon />
          </Fab>
        </Box>

        {step === 0 && qrCode && !verifySuccess && (
          <>
            <Box className="tfa-modal-content">
              <Typography variant="title">{t('messages:login.otp.turnOn2FA')}</Typography>
              <Typography variant="subtitle3">{t('messages:login.otp.turnOn2FADesc')}</Typography>
            </Box>
            <Paper className="qr-code-container">
              <QRCodeCanvas value={qrCode} size={200} />
            </Paper>
            <Button onClick={handleNext} variant="contained" fullWidth>
              {t('common:continue')}
            </Button>
            <Divider>
              <Typography variant="subtitle3">{t('messages:login.otp.enterManually')}</Typography>
            </Divider>
            <Box className="manual-code-container">
              <TextField value={secret} disabled fullWidth />
              <Fab
                className="tfa-copy-button"
                onClick={() => {
                  navigator.clipboard.writeText(secret)
                }}
              >
                <ContentCopyOutlinedIcon />
              </Fab>
            </Box>
          </>
        )}
        {step === 1 && !verifySuccess && (
          <>
            <Box className="tfa-modal-content">
              <Typography variant="title">{t('messages:login.otp.verifyCode')}</Typography>
              <Typography variant="subtitle3">{t('messages:login.otp.enter6Code')}</Typography>
            </Box>
            <OTPInput
              inputStyle={`otp-input ${theme === 'dark' ? 'otp-input-dark' : 'otp-input-light'}`}
              renderSeparator={<span className="otp-separator">-</span>}
              value={otp}
              onChange={setOtp}
              numInputs={6}
              shouldAutoFocus
              renderInput={(props) => <input {...props} data-1p-ignore inputMode="numeric" />}
            />
            {isProcessing ? (
              <ProcessingSpinner message={t('common:processing')} />
            ) : (
              <Button onClick={handleNext} variant="contained" fullWidth>
                {t('messages:login.otp.complete2Step')}
              </Button>
            )}
          </>
        )}
        {verifySuccess && (
          <>
            <Box className="tfa-success-container">
              <Box className="tfa-success-content">
                <Typography variant="title">{t('messages:login.otp.2StepCompleted')}</Typography>
                <Divider>
                  <Typography variant="subtitle3">{t('messages:login.otp.youCanLogin')}</Typography>
                </Divider>
              </Box>
              <Button onClick={onClose} variant="contained" fullWidth>
                {t('messages:login.otp.backToLogin')}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  )
}

export default TwoFactorActivationModal
